interface IDisturbanceCookieData {
    closed: boolean;
    id: string;
}
export default class Disturbance {
    readonly htmlElement: HTMLHtmlElement;
    readonly disturbanceElement: HTMLDivElement | null;
    readonly resizeObserver: ResizeObserver | null;
    
    constructor() {
        this.htmlElement = document.documentElement as HTMLHtmlElement;
        this.disturbanceElement = document.querySelector('.disturbance');
        this.resizeObserver = typeof ResizeObserver === 'function'
            ? new ResizeObserver((): void => {
                this.updateHeight();
            })
            : null;
        
        this.init();
    }

    private init(): void {
        if (this.disturbanceElement) {
            this.updateHeight();
            this.resizeObserver?.observe(this.disturbanceElement);

            const closeButton = document.querySelector('.disturbance__close-button') as HTMLButtonElement;

            closeButton.addEventListener('click', (): void => {
                this.closeMessage();
            });
        }
    }

    private updateHeight(): void {
        const height = this.disturbanceElement?.getBoundingClientRect().height ?? 0;
        this.htmlElement.style.setProperty('--disturbance-height', `${height}px`);
    }
    
    private closeMessage(): void {
        this.resizeObserver?.disconnect();
        this.disturbanceElement?.classList.add('disturbance--hidden');
        this.htmlElement.style.setProperty('--disturbance-height', '0px');
        const id = (this.disturbanceElement?.querySelector('#disturbance-id') as HTMLInputElement).value;
        const siteName = (this.disturbanceElement?.querySelector('#disturbance-id')?.getAttribute('data-site'));
        
        if (id != null) {
            const cookieData: IDisturbanceCookieData = {
                closed: true,
                id: id
            };
            var cookieName = siteName + '_disturbance';
            this.setCookie(cookieName, cookieData, 2); // Set the cookie to expire in 2 days 
        }
    }
    
    private setCookie(name: string, value: IDisturbanceCookieData, days: number): void {
        const expires = new Date();
        expires.setDate(expires.getDate() + days);
        const cookieValue = encodeURIComponent(JSON.stringify(value)) + `; expires=${expires.toUTCString()}; path=/`;
        document.cookie = `${name}=${cookieValue}`;
    }
}
